<script setup lang="ts">
import AppPlaceholderLayout from './AppPlaceholderLayout.vue';

interface AppBasePlaceholderProps {
  title: string;
  description: string;
  isSmallDevice: boolean;
  isLoading?: boolean;
  isPrintMode?: boolean;
}
const props = defineProps<AppBasePlaceholderProps>();
</script>

<template>
  <AppPlaceholderLayout
    class="app-custom-placeholder"
    :class="{ mobile: props.isSmallDevice }"
    :description="props.description"
    :title="props.title"
    :is-loading="props.isLoading"
    :is-small-device="props.isSmallDevice"
    :is-print-mode="props.isPrintMode"
  >
    <template #left-content>
      <slot name="left-content" />
    </template>
    <template #actions><slot name="actions" /></template>
  </AppPlaceholderLayout>
</template>

<style scoped lang="scss">
.app-custom-placeholder {
  border: 1px solid var(--color-scrollbar);

  &.mobile {
    :deep(.main-content) {
      flex-direction: row;
    }
  }
}
</style>
